<section class="bem-vindo">
  <img src="assets/images/verify-safe-1.png" width="200" alt="seguranca" />

  <div class="bem-vindo__title">
    Olá, você está em um ambiente seguro da <br />
    <strong class="text-blue">Omni Financeira</strong>
  </div>

  <p>
    A partir de agora, vamos iniciar o
    <strong>processo de segurança e privacidade</strong> para o seu
    financiamento Omni.
  </p>

  <div class="subtitle">Vamos lá?</div>
</section>
